// HANDLER: Entity
const ENTITY_URL_PART: Record<Entity, string> = {
  match: 'matches',
  series: 'series',
  tournament: 'tournaments'
};

const URL_VIDEOGAME_MAPPING: Partial<Record<VideogameSlug, string>> = {
  'league-of-legends': 'lol',
  'cs-go': 'csgo',
  'dota-2': 'dota2'
};

const getVideogameUrl = (videogame: VideogameSlug | null): string | undefined => {
  if (videogame) {
    const mappedUrl = URL_VIDEOGAME_MAPPING[videogame];
    if (mappedUrl) {
      return mappedUrl;
    }
  }
  return undefined;
};

const getOriginUrl = (): string => window.origin;

const getBackendUrl = (): string => {
  // Explicit backend host, set only by deployments whose hostname the fallback
  // below cannot derive from — e.g. widget-cdn.pandascore.co, where the
  // substring swap would yield the nonexistent ratchet-cdn.pandascore.co.
  if (import.meta.env.VITE_BACKEND_URL) {
    return import.meta.env.VITE_BACKEND_URL;
  }
  const origin = getOriginUrl();
  if (origin.includes('localhost')) {
    return import.meta.env.VITE_API_URL ?? '';
  }
  if (origin) {
    return origin.replace('widget', 'ratchet');
  }
  return '';
};

const getWsUrl = (): string => {
  const backend = getBackendUrl();
  if (backend) {
    return `${backend.replace('https://', 'wss://')}/socket`;
  }
  return '';
};

const getMicrobetWsUrl = (): string => {
  const microbetWsUrl = import.meta.env.VITE_MICROBET_WS_URL;
  return microbetWsUrl ? `${microbetWsUrl}/betting/microbetting` : '';
};

// Rewrites an API-served image (team logo, map, hero...) onto the CDN proxy
// host, same as the widget's own JS/CSS — see CDN_ASSETS_BASE_URL in
// vite.config.ts. Only the host changes; the bucket path stays as returned by
// the API, since the proxy fronts cdn.pandascore.co as a whole.
const getCDNUrl = (imageUrl: string): string => {
  const assetsBaseUrl = import.meta.env.VITE_ASSETS_BASE_URL;
  if (!assetsBaseUrl || !imageUrl) {
    return imageUrl;
  }
  const url = new URL(imageUrl);
  const base = new URL(assetsBaseUrl);
  url.protocol = base.protocol;
  url.host = base.host;
  return url.toString();
};

export {
  getOriginUrl,
  ENTITY_URL_PART,
  getVideogameUrl,
  getBackendUrl,
  getWsUrl,
  getMicrobetWsUrl,
  getCDNUrl
};
